import React from 'react';
import { Loader } from '../icons/OurIcons';

const buttonStyling = `flex w-full bg-white text-reix-blue border border-reix-blue gap-2
text-nowrap h-full rounded-md items-center px-4`;

type IconButtonProps = {
  icon: React.ReactNode;
  label: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  loading?: boolean;
};

export const IconButton = ({
  icon,
  label,
  onClick,
  loading,
}: IconButtonProps) => {
  if (loading) {
    return (
      <button className={buttonStyling}>
        <div className="w-6">
          <Loader />
        </div>
        <p>{label}</p>
      </button>
    );
  }

  return (
    <button className={buttonStyling} onClick={onClick}>
      {icon}
      <p>{label}</p>
    </button>
  );
};
